/** UserService */
// User URLO
export const USER_LOGIN = "/api/user/login";
export const QUICK_LOGIN = "/api/login/quick";
export const USER_REGISTER_POST = "/api/user/register";
export const GET_OPERATE_TOKEN = "/health/handle/token";
export const PASSWORD_MOD = "/api/user/password/mod";
export const USER_INFO_MOD = "/api/user/info/mod";
export const USER_ACCOUNT_GET = "/api/user/sale/get";
export const USER_INFO_GET = "/api/user/info/get";
export const VCODE_GET = "/api/vcode/get";

// 获取所有部门
export const COMMON_DEPT_ALL_GET = "/api/dept/all";
// 根据部门id获取部门用户
export const COMMON_USER_BY_DEPT_GET = "/api/dept/user/get";
// 获取所有的产品维护管理员
export const COMMON_ROLE_PRODUCT_MANAGER_GET = "/api/role/productmanager/list/get";
/** 获取所有下载中的文件 */
export const COMMON_DOWNLOADING_FILE_GET = "/api/file/download/process/list";
/** 删除文件下载列表数据 */
export const COMMON_DOWNLOADING_FILE_DEL_POST = "/api/file/download/process/del";
/** 获取物料编号信息 */
export const COMMON_MATERIAL_LIST_GET = "/api/common/material/list/get";

export const FILE_DOWNLOAD_GET = "/api/file/download";
// 上传文件生成md5并返回
export const FILE_UPLOAD_MD5_GET = "/api/file/md5/upload";
export const FILE_UPLOAD_POST = "/api/file/upload";
export const FILE_UPLOAD_RETURN_ALL_POST = "/api/file/upload";
export const FILE_ONLINE_URL_GET = "/api/file/online/read";
/** 文件下载(不带进度条) */
export const FILE_DOWNLOAD_NO_PROCESS = "/api/file/download/without/process";
// 全局搜索
export const SEARCH_GLOBAL_GET = "/api/system/search/global";

/** 获取用户关联区域 */
export const USER_AREA_INFO_GET = "/api/user/area/info/get";

//project
export const PROJECT_LIST_GET = "/api/project/my/get";
export const PRODUCT_SELECT_LIST_GET = "/api/project/product/get";
// 预测类别
export const PROJECT_FORECAST_CATEGORY = "/api/forecast/category/get";
// 项目阶段
export const PROJECT_STAGE = "/api/project/stage/get";
// 加载常量列表
export const PROJECT_CONSTANT_LIST_GET = "/api/project/constant/list/get";
// 添加常量
export const PROJECT_CONSTANT_ADD_POST = "/api/project/constant/add";
// 修改常量
export const PROJECT_CONSTANT_MOD_POST = "/api/project/constant/mod";
// 删除常量
export const PROJECT_CONSTANT_DEL_POST = "/api/project/constant/del";
// 导出项目
export const PROJECT_EXPORT_POST = "/api/project/export";
// 查看项目日志
export const PROJECT_LOG_GET = "/api/project/history/get";
// 获取商机详情
export const PUBLIC_DETAIL_GET = "/api/project/detail/get";
/** 相似商机 */
export const PUBLIC_HAS_SIMILARITY = "/api/project/semilar/check";

//system
// 功能模块使用上报
export const COMMON_FREQUENCY_REPORT_POST = "/api/common/module/use/frequency/report";
export const PRODUCT_MODEL_LIST_GET = "/api/product/category/list";
export const OPERATION_LOG_LIST_GET = "/api/log/list";
export const OPERATION_LOG_TYPE_LIST_GET = "/api/log/operation/list";
export const SETTING_GET = "/api/system/setting/get";
export const SETTING_LIST_GET = "/api/system/setting/list/get";
export const CURRENT_TIME_GET = "/api/system/curtime";
// 查看产品授权列表
export const SETTING_AUTHORIZE_GET = "/api/authorization/config/get";
// 添加设备型号授权配置
export const SYSTEM_AUTH_ADD_POST = "/api/authorization/config/add";
// 修改设备型号授权配置
export const SYSTEM_AUTH_MOD_POST = "/api/authorization/config/update";
// /api/authorization/config/delete
export const SYSTEM_AUTH_DEL_POST = "/api/authorization/config/delete";
// 获取所有设备型号信息
export const SYSTEM_MODEL_LIST_GET = "/api/model/all/get";
// 授权的型号列表获取
export const AUTHORIZE_MODEL_ALL_GET = "/api/model/auth/all/get";
// 获取产品线
export const SYSTEM_PRODUCT_LINE_LIST_GET = "/api/productline/list/get";
// 加载系统版本数据
export const SYSTEM_VRESION_LIST_GET = "/api/system/versionLog/list/get";
// 添加系统版本数据
export const SYSTEM_VERSION_ADD_POST = "/api/system/versionLog/add";
// 修改系统版本数据
export const SYSTEM_VERSION_UPDATE_POST = "/api/system/versionLog/mod";
// 删除系统版本数据
export const SYSTEM_VERSION_DELETE_POST = "/api/system/versionLog/del";
// 加载公开文件
export const SYSTEM_PUBLIC_FILE_LIST_GET = "/api/system/public/file/list/get";
// 添加公开文件
export const SYSTEM_PUBLIC_FILE_ADD_POST = "/api/system/public/file/add";
// 修改文件状态
export const SYSTEM_PUBLIC_FILE_MOD_POST = "/api/system/public/file/mod";
// 删除公开文件接口
export const SYSTEM_PUBLIC_FILE_DEL_POST = "/api/system/public/file/del";
// 更新文件浏览量
export const SYSTEM_PUBLIC_FILE_VIEWS_MOD_POST = "/api/system/public/file/views/mod";
// 下载公开文件并更新下载量
export const SYSTEM_PUBLIC_FILE_DOWNLOADS_MOD_GET = "/api/system/public/file/download";
/** 获取地区码配置分页信息 */
export const SYSTEM_AREA_CODE_LIST_GET = "/api/system/area/code/config/page/get";
/** 增加地区码配置 */
export const SYSTEM_AREA_CODE_ADD_POST = "/api/system/area/code/config/add";
/** 修改地区码配置 */
export const SYSTEM_AREA_CODE_MOD_POST = "/api/system/area/code/config/update";
/** 删除地区码配置 */
export const SYSTEM_AREA_CODE_DEL_POST = "/api/system/area/code/config/del";

/** 获取项目配置 */
export const SYSTEM_PROJECT_CONFIG_GET = "/api/system/project/config/get";
/** 保存项目配置 */
export const SYSTEM_PROJECT_CONFIG_MOD = "/api/system/project/config/update";

/** 目标业务列表 */
export const SYSTEM_TARGET_BUSINESS_LIST_GET = "/api/system/target/business/page/get";
/** 添加目标业务 */
export const SYSTEM_TARGET_BUSINESS_ADD_POST = "/api/system/target/business/add";
/** 编辑目标业务 */
export const SYSTEM_TARGET_BUSINESS_MOD_POST = "/api/system/target/business/update";
/** 删除目标业务 */
export const SYSTEM_TARGET_BUSINESS_DEL_POST = "/api/system/target/business/del";

/** 内部用户列表 */
export const SPECIAL_USER_LIST_GET = "/api/special/user/list";
/** 特殊用户组列表获取 */
export const SPECIAL_GROUP_LIST_GET = "/api/special/group/list";
/** 添加特殊用户组 */
export const SPECIAL_GROUP_ADD_POST = "/api/special/group/add";
/** 修改特殊用户组信息 */
export const SPECIAL_GROUP_MOD_POST = "/api/special/group/mod";
/** 特殊用户组删除 */
export const SPECIAL_GROUP_DEL_POST = "/api/special/group/del";
/** 特殊用户组详情获取 */
export const SPECIAL_GROUP_DETAIL_GET = "/api/special/group/get";
/** 修改特殊用户组关联用户 */
export const SPECIAL_GROUP_USER_MOD_POST = "/api/special/group/user/mod";
/** 修改特殊用户组关联权限 */
export const SPECIAL_GROUP_PERMISSION_MOD_POST = "/api/special/group/permission/mod";
/** 特殊权限列表 */
export const SPECIAL_PERMISSION_LIST_GET = "/api/special/permission/list";

// sale
export const SALE_LIST_GET = "/api/user/sale/list";
export const SALE_AUDIT = "/api/user/sale/audit";
export const SALE_DEL = "/api/user/sale/del";
export const SALE_AGENT_ASSIGN = "/api/user/sale/agent/assign";
export const SALE_AGENT_ADD_POST = "/api/user/agent/sale/add";
export const SALE_LIST_BY_AGENT_GET = "/api/user/agent/sale/list/get";
export const SALE_AGENT_DEL_POST = "/api/user/agent/sale/del";
export const SALE_AGENT_ADMIN_SET_POST = "/api/user/sale/admin/set";

// agent
export const SALE_AGENT_LIST_GET = "/api/user/sale/agent/get";
export const AGENT_LIST_GET = "/api/user/agent/list";
export const AGENT_DETAIL_GET = "/api/user/agent/get";
export const AGENT_AUDIT = "/api/user/agent/audit";
export const AGENT_SALE_CHANGE = "/api/user/agent/sale/change";
export const AGENT_SCORE_GET = "/api/user/agent/mark/get";
export const AGENT_DEL = "/api/user/agent/del";
export const AGENT_MOD = "/api/user/agent/mod";
/** 添加代理商分销商关卡 */
export const AGENT_DISTRIBUTION_ADD_POST = "/api/user/agent/distribution/add";
/** 删除代理商分销商关卡 */
export const AGENT_DISTRIBUTION_DEL_POST = "/api/user/agent/distribution/del";
/** 获取代理商分销商关卡 */
export const AGENT_DISTRIBUTION_GET = "/api/user/agent/distribution/get";
// 导出代理商列表
export const AGENT_EXPORT = "/api/user/agent/list/export";
// 同步代理商列表
export const AGENT_USER_SYNC_POST = "/api/user/agent/eab/synchronization";
// 修改代理商的渠道经理的排序
export const AGENT_USER_SALE_SORT_POST = "/api/user/agent/sale/sort/update";
// 修改代理商的商机报备的审核类型
export const AGENT_USER_PROJECT_EXAMINE_MOD_POST = "/api/user/agent/project/examine/update";

// agent sub account
export const AGENT_SUB_ACCOUNT_LIST_GET = "/api/user/agent/child/account/list/get";
export const AGENT_SUB_ACCOUNT_MODIFY_POST = "/api/user/agent/child/account/mod";
export const AGENT_SUB_ACCOUNT_DEL_POST = "/api/user/agent/child/account/del";

export const AGENT_LEVEL_LIST_GET = "/api/user/agent/level/list/get";
export const AGENT_LEVEL_ADD_POST = "/api/user/agent/level/add";
export const AGENT_LEVEL_MOD_POST = "/api/user/agent/level/mod";
export const AGENT_LEVEL_DEL_POST = "/api/user/agent/level/del";
export const AGENT_CHILD_TRANSFER_POST = "/api/user/agent/child/transfer";

// offer
export const OFFER_LIST_GET = "/api/quotation/list";

// area
export const AREA_INFO_GET = "/api/area/get";

// group
export const GROUP_LIST_GET = "/api/role/list";
export const CUR_GROUP_GET = "/api/role/get";
export const GROUP_ADD = "/api/role/add";
export const GROUP_MOD = "/api/role/mod";
export const GROUP_DEL = "/api/role/del";
export const PRIVILIGE_LIST_GET = "/api/role/permission/list";
export const GROUP_PRIVILEGE_MOD = "/api/role/permission/mod";
export const GROUP_USER_MOD = "/api/role/user/mod";
// 职位权限获取
export const USER_JOB_PRIVILEGE_GET = "/api/user/job/privilege/get";
// 职位权限编辑
export const USER_JOB_PRIVILEGE_MOD_POST = "/api/user/job/privilege/edit";

// manager user
export const MANAGER_USER_ADD = "/api/user/add";
export const MANAGER_USER_MOD = "/api/user/mod";
export const MANAGER_USER_DEL = "/api/user/del";
export const MANAGER_USER_LIST = "/api/user/list";
export const MANAGER_USER_SALE_SET_POST = "/api/user/sale/set";


export const AREA_LIST_GET = "/api/area/get";

/*  星战友  */
// COLLECTION
export const COLLECTION_PRODUCTS_GET = "/api/collection/list/get";
export const COLLECTION_PRODUCT_ADD_POST = "/api/collection/add";
export const COLLECTION_PRODUCT_DEL_POST = "/api/collection/del";
// CART
export const CART_PRODUCT_ADD_POST = "/api/cart/add";
export const CART_PRODUCT_MOD_POST = "/api/cart/mod";
export const CART_PRODUCT_DEL_POST = "/api/cart/del";
export const CART_GET_GET = "/api/cart/get";
export const CART_FAST_ADD_POST = "/api/cart/fast/add";
// QUOTATION
export const QUOTATION_PRESET_GET = "/api/quotation/preset/get";
export const QUOTATION_COPY_PRESET_GET = "/api/quotation/copy/preset/get";
export const QUOTATION_DETAIL_GET = "/api/quotation/detail/get";
export const QUOTATION_LIST_GET = "/api/quotation/list";
export const QUOTATION_DRAFT_ADD_POST = "/api/quotation/draft/add";
export const QUOTATION_DRAFT_MOD_POST = "/api/quotation/draft/mod";
export const QUOTATION_DRAFT_DEL_POST = "/api/quotation/draft/del";
export const QUOTATION_TRASH_DEL_POST = "/api/quotation/trash/del";
export const QUOTATION_TRASH_RESTORE_POST = "/api/quotation/trash/restore";
export const QUOTATION_FORMAL_ADD_POST = "/api/quotation/formal/add";
export const QUOTATION_INFO_CLASS_MOD_POST = "/api/quotation/info/mod";
export const QUOTATION_INFO_EXPORT_GET = "/api/quotation/export";
// 报价单修改为草稿状态
export const QUOTATION_DRAFT_CHANGE_POST = "/api/quotation/draft/change";
// 根据target id获取报价单详情
export const QUOTATION_DETAIL_BY_TARGET_GET = "/api/quotation/by/target/detail/get";
// 根据target id获取报价单历史
export const QUOTATION_DETAIL_BY_HISTORY_GET = "/api/quotation/by/target/history/get";
// QUOTATION CLASS
export const QUOTATION_CLASS_LIST_GET = "/api/quotation/type/get";
export const QUOTATION_CLASS_ADD_POST = "/api/quotation/type/add";
export const QUOTATION_CLASS_DEL_POST = "/api/quotation/type/del";
export const QUOTATION_CLASS_MOD_POST = "/api/quotation/type/mod";

// PRODUCT
export const PRODUCT_LIST_GET = "/api/product/list";
export const PRODUCT_DETAIL_GET = "/api/product/get";
export const PRODUCT_DETAIL_NOW_GET = "/api/product/now/get";
export const PRODUCT_ADD_POST = "/api/product/add";
export const PRODUCT_UPDATE_POST = "/api/product/update";
export const PRODUCT_ACTIVE_POST = "/api/product/active";
export const PRODUCT_INACTIVE_POST = "/api/product/inactive";
export const PRODUCT_DELETE_POST = "/api/product/delete";
export const PRODUCT_EXPORT_GET = "/api/product/export";
export const PRODUCT_CATEGORY_GET = "/api/product/category/list";
export const PRODUCT_CATEGORY_ADD_POST = "/api/product/category/add";
export const PRODUCT_CATEGORY_UPDATE_POST = "/api/product/category/update";
export const PRODUCT_CATEGORY_DELETE_POST = "/api/product/category/delete";

/** 产品小类列表获取 */
export const PRODUCT_CATEGORY_SUB_LIST_GET = "/api/product/category/sub/list";
/** 添加产品小类 */
export const PRODUCT_CATEGORY_SUB_ADD_POST = "/api/product/category/sub/add";
/** 编辑产品小类 */
export const PRODUCT_CATEGORY_SUB_MOD_POST = "/api/product/category/sub/update";
/** 删除产品小类 */
export const PRODUCT_CATEGORY_SUB_DEL_POST = "/api/product/category/sub/delete";

// 产品信息导出V1.0.1
export const PRODUCT_LIST_EXPORT_POST = "/api/product/export";

export const PRODUCT_CLASSIFY_LIST_GET = "/api/product/classify/list/get";
export const PRODUCT_CLASSIFY_ADD_POST = "/api/product/classify/add";
export const PRODUCT_CLASSIFY_MOD_POST = "/api/product/classify/update";
export const PRODUCT_CLASSIFY_DEL_POST = "/api/product/classify/delete";

export const PRODUCT_MAJOR_UPGRADE_LIST_GET = "/api/product/upgrade/list/get";
export const PRODUCT_MAJOR_UPGRADE_ADD_POST = "/api/product/upgrade/add";
export const PRODUCT_MAJOR_UPGRADE_MOD_POST = "/api/product/upgrade/update";
export const PRODUCT_MAJOR_UPGRADE_DEL_POST = "/api/product/upgrade/delete";

export const PRODUCT_INDUSTRY_LIST_GET = "/api/project/industry/list/get";
export const PRODUCT_INDUSTRY_ADD_POST = "/api/project/industry/add";
export const PRODUCT_INDUSTRY_MOD_POST = "/api/project/industry/mod";
export const PRODUCT_INDUSTRY_DEL_POST = "/api/project/industry/del";

export const PRODUCT_CHANGE_LIST_GET = "/api/product/change/history/list/get";
// 获取产品变更列表
export const PRODUCT_CHANGE_LIST_PAGE_GET = "/api/product/change/history/page/get";
/** 公告置顶 */
export const PRODUCT_CHANGE_TOP_POST = "/api/product/change/top";
/** 取消公告置顶 */
export const PRODUCT_CHANGE_TOP_CANCEL_POST = "/api/product/change/top/cancel";

export const PRODUCT_PROMOTION_LIST_GET = "/api/product/promotion/list/get";
export const PRODUCT_PROMOTION_ADD_POST = "/api/product/promotion/add";
export const PRODUCT_PROMOTION_MOD_POST = "/api/product/promotion/update";
export const PRODUCT_PROMOTION_DEL_POST = "/api/product/promotion/delete";
export const PRODUCT_PROMOTION_EXPORT_GET = "/api/product/promotion/export";

// 报价发布
export const QUOTATION_RELEASE_LIST_GET = "/api/product/quotation/list/get";
export const QUOTATION_RELEASE_DETAIL_GET = "/api/product/quotation/detail/get";
export const QUOTATION_RELEASE_ADD_POST = "/api/product/quotation/add";
export const QUOTATION_RELEASE_MOD_POST = "/api/product/quotation/update";
export const DOWNLOAD_QUOTATION_RELEASE_TEMPLATE_GET = "/api/product/quotation/product/download";
export const UPLOAD_QUOTATION_RELEASE_TEMPLATE_POST = "/api/product/quotation/product/import/detail/get";
export const QUOTATION_RELEASE_DEL_POST = "/api/product/quotation/delete";
export const QUOTATION_RELEASE_CLOSE_POST = "/api/product/quotation/close";
export const QUOTATION_RELEASE_BY_TARGET_GET = "/api/product/quotation/by/target/detail/get";
export const QUOTATION_RELEASE_HISTORY_BY_TARGET_GET = "/api/product/quotation/history/by/target/list/get";
export const QUOTATION_RELEASE_HISTORY_GET = "/api/product/quotation/history/list/get";
export const QUOTATION_RELEASE_HISTORY_APPROVE_GET = "/api/product/quotation/approve/history/list/get";

// 文档发布
export const DOC_RELEASE_LIST_GET = "/api/doc/launch/doc/list/get";
export const DOC_RELEASE_ADD_POST = "/api/doc/launch/doc/create";
export const DOC_RELEASE_REVOKE_POST = "/api/doc/launch/doc/revoke";
export const DOC_RELEASE_RESET_POST = "/api/doc/launch/doc/reset/create";
export const DOC_RELEASE_DELETE_POST = "/api/doc/launch/doc/delete";
export const DOC_RELEASE_BY_TARGET_GET = "/api/doc/launch/doc/info/get";
export const DOC_RELEASE_HISTORY_APPROVE_GET = "/api/doc/launch/doc/approve/history/list/get";

// FAQ发布
export const FAQ_RELEASE_LIST_GET = "/api/faq/launch/list/get";
export const FAQ_RELEASE_ADD_POST = "/api/faq/launch";
export const FAQ_RELEASE_ADD_DRAFT_POST = "/api/faq/launch/draft/save";
export const FAQ_RELEASE_MOD_POST = "/api/faq/launch/update";
export const FAQ_RELEASE_REVOKE_POST = "/api/faq/launch/revoke";
export const FAQ_RELEASE_RESET_POST = "/api/faq/launch/reset/launch";
export const FAQ_RELEASE_DEL_POST = "/api/faq/launch/delete";
export const FAQ_RELEASE_BY_TARGET_GET = "/api/faq/launch/detail/get";

// FAQ
export const FAQ_LIST_GET = "/api/faq/faq/list/get";
export const FAQ_ALL_LIST_GET = "/api/faq/faq/all/list/get";
export const FAQ_TREE_GET = "/api/faq/faq/navigation/tree";
export const FAQ_DETAIL_ALLL_GET = "/api/faq/faq/all/detail/get";
export const FAQ_DETAIL_GET = "/api/faq/faq/detail/get";
export const FAQ_EDIT_POST = "/api/faq/faq/update";
export const FAQ_DEL_POST = "/api/faq/faq/delete";
export const FAQ_DOWN_POST = "/api/faq/faq/down";

// SUITE
export const SUITE_LIST_GET = "/api/product/suite/list";
export const SUITE_ADD_POST = "/api/product/suite/add";
export const SUITE_UPDATE_POST = "/api/product/suite/update";
export const SUITE_DELETE_POST = "/api/product/suite/delete";
export const SUITE_ACTIVE_POST = "/api/product/suite/active";
export const SUITE_INACTIVE_POST = "/api/product/suite/inactive";
export const PRODUCT_SUITE_GET = "/api/product/suite/get"; // 套件详情
export const SUITE_FIT_PRODUCT_GET = "/api/product/suite/getbymainproductid"; // 获取配件（不包含主产品）

// SOLUTION
export const SOLUTION_LIST_GET = "/api/product/case/list";
export const SOLUTION_DETAIL_GET = "/api/product/case/get";
export const SOLUTION_ADD_POST = "/api/product/case/add";
export const SOLUTION_UPDATE_POST = "/api/product/case/update";
export const SOLUTION_DELETE_POST = "/api/product/case/delete";
export const SOLUTION_ACTIVE_POST = "/api/product/case/active";
export const SOLUTION_INACTIVE_POST = "/api/product/case/inactive";
// 设置置顶
export const SOLUTION_SET_UP_OR_DOWN_POST = "/api/product/case/set/top";
// 查看历史记录
export const SOLUTION_HISTORY_GET = "/api/product/case/history/get";
// 下载文件
export const SOLUTION_FILE_GET = "/api/product/case/file/download";
// 调整方案的浏览量
export const SOLUTION_VIEW_MOD_POST = "/api/product/case/views/update";
// 获取成功案例的区域信息
export const PRODUCT_CASE_AREA_GET = "/api/product/case/area/list";

// 解决方案分类管理
// 加载一级分类
export const SOLUTION_LV_ONE_LIST_GET = "/api/product/case/lv1/list/get";
// 添加一级分类
export const SOLUTION_LV_ONE_ADD_POST = "/api/product/case/lv1/add";
// 修改一级分类
export const SOLUTION_LV_ONE_MOD_POST = "/api/product/case/lv1/mod";
// 删除一级分类
export const SOLUTION_LV_ONE_DEL_POST = "/api/product/case/lv1/del";
// 获取二级分类
export const SOLUTION_LV_TWO_LIST_GET = "/api/product/case/lv2/list/get";
// 添加二级分类
export const SOLUTION_LV_TWO_ADD_POST = "/api/product/case/lv2/add";
// 修改二级分类
export const SOLUTION_LV_TWO_MOD_POST = "/api/product/case/lv2/mod";
// 删除二级分类
export const SOLUTION_LV_TWO_DEL_POST = "/api/product/case/lv2/del";

// AUTHORIZE
// 查看智慧OA授权生成记录
export const AUTHORIZE_LIST_GET = "/api/authorization/import/record/list";
// 加载授权的统计数据
export const AUTHORIZE_INFO_LIST_GET = "/api/authorization/stat/record/page/list";
// 加载激活授权记录列表
export const ACTIVE_LIST_GET = "/api/authorization/active/record/page/list";
// 根据sn信息获取授权型号/产品型号等
export const AUTHORIZE_INFO_BY_SN_GET = "/api/authorization/authInfo/by/sn/get";
// 根据KEY信息获取授权型号/产品型号等V1.0
export const AUTHORIZE_INFO_BY_KEY_GET = "/api/authorization/authInfo/by/key/get";
// 获取授权剩余数量
export const AUTHORIZE_RESIDUE_NUMBER_GET = "/api/authorization/residue/number/get";
// 添加激活授权记录
export const AUTHORIZE_ACTIVE_ADD_POST = "/api/authorization/active/record/add";
// 授权相关文件下载
export const ACTIVE_FILE_DOWNLOAD = "/api/authorization/file/download";
// 智慧oa授权信息录入
export const AUTHORIZE_IMPORT_ADD_POST = "/api/authorization/import/record/add";
// 获取配置授权信息的物料料号
export const AUTHORIZE_MATERIAL_LIST_GET = "/api/authorization/supplymaterial/with/auth/list";
// 导入授权激活信息
export const AUTHORIZE_IMPORT_POST = "/api/authorization/import/record";
// 删除授权激活记录
export const ACTIVE_DEL_POST = "/api/authorization/active/record/delete";
// 下载导入模板
export const ACTIVE_TEMPLATE_DOWNLOAD_GET = "/api/authorization/import/template/download";
// 加载激活授权详情记录列表V1.0
export const ACTIVE_DETAIL_GET = "/api/authorization/active/record/detail/get";
// 获取sn或mac最后一次授权文件的md5值
export const AUTHORIZE_LAST_FILE_MD5_GET = "/api/authorization/authInfo/lastfile/md5/get";

// 我的代办
// 获取我的代办
export const MY_TODO_LIST_GET = "/api/todo/my/list/get";
// 根据日志id获取项目全部日志
export const PROJECT_HISTORY_BY_TARGET_GET = "/api/project/history/by/target/get";
// 根据模块日志id获取历史记录
export const PRODUCT_CASE_HISTORY_BY_TARGET_GET = "/api/product/case/target/history/get";
// 根据历史id查看全部历史信息
export const PRODUCT_HISTORY_BY_TARGET_GET = "/api/product/target/history/get";
// 根据日志id获取项目信息
export const PROJECT_BY_TARGET_GET = "/api/project/by/target/get";
// 根据日志id获取方案详情信息
export const PRODUCT_CASE_BY_TARGET_GET = "/api/product/case/target/get";
// 根据日志id获取产品详情
export const PRODUCT_BY_TARGET_GET = "/api/product/target/get";
// 审批
export const TODO_AUDIT_POST = "/api/todo/audit";
// 获取待办日志
export const TODO_HISTORY_LIST_GET = "/api/todo/audit/log/list/get";

/** 分页获取规则列表 */
export const TODO_RULE_LIST_GET = "/api/rule/list/get";
/** 添加规则 */
export const TODO_RULE_ADD_POST = "/api/rule/add";
/** 修改规则 */
export const TODO_RULE_MOD_POST = "/api/rule/update";
/** 删除规则 */
export const TODO_RULE_DEL_POST = "/api/rule/delete";

// 资料管理相关
// 获取资料列表
export const DOC_LIST_GET = "/api/doc/list/get";
// 创建资料
export const DOC_ADD_POST = "/api/doc/create";
// 编辑资料
export const DOC_MOD_POST = "/api/doc/update";
// 删除资料
export const DOC_DEL_POST = "/api/doc/delete";
// 修改资料状态
export const DOC_STATUS_MOD_POST = "/api/doc/status/update";
// 批量修改资料状态
export const DOC_STATUS_MOD_BATCH_POST = "/api/doc/status/update/batch";
// 资料下载
export const DOC_FILE_DOWNLOAD_POST = "/api/doc/download";
/** 资料操作历史 */
export const DOC_FILE_HISTORY_POST = "/api/doc/history/get";
/** 获取资料上一次发布对象配置 */
export const DOC_FILE_HISTORY_SHARE_GET = "/api/doc/history/shares/get";

// 下载资料
export const DOC_CENTER_FILE_DOWNLOAD_POST = "/api/doc/center/doc/download";
// 资料树
export const DOC_CENTER_TREE_GET = "/api/doc/center/tree";
// 获取资料列表
export const DOC_CENTER_LIST_GET = "/api/doc/center/doc/list/get";
// 资料在线阅读
export const DOC_READ_GET = "/api/doc/read";

// 获取资料分类列表
export const DOC_TYPE_LIST_GET = "/api/doc/type/list/get";
// 创建资料分类
export const DOC_TYPE_ADD_POST = "/api/doc/type/create";
// 编辑资料分类
export const DOC_TYPE_MOD_POST = "/api/doc/type/update";
// 删除资料分类
export const DOC_TYPE_DEL_POST = "/api/doc/type/delete";
// 资料在线阅读
export const DOC_CENTER_READ_GET = "/api/doc/center/read";

// 根据产品型号获取硬件版本数组
export const SOFTWARE_HARDWARE_LIST_GET = "/api/software/info/hardware/list/get";
// 生成下载链接（默认有效时间为1天）
export const SOFTWARE_SHARE_URL_GET = "/api/software/info/download/url/get";
/** 下载软件发布补丁或者版本升级包 */
export const SOFTWARE_DOWNLOAD_GET = "/api/software/info/download";

// 获取软件发布分页信息
export const SOFTWARE_RELEASE_LIST_GET = "/api/software/info/page/get";
// 导出软件版本发布
export const SOFTWARE_EXPORT_GET = "/api/software/info/export";
// 软件发布
export const SOFTWARE_RELEASE_POST = "/api/software/info/release";
// 编辑软件发布
export const SOFTWARE_UPDATE_POST = "/api/software/info/update";
// 停用软件
export const SOFTWARE_DEACTIVATE_POST = "/api/software/info/deactivate";
// 启用版本发布
export const SOFTWARE_ENABLE_POST = "/api/software/info/enable";
// 根据软件版本id获取型号和硬件版本
export const SOFTWARE_MODEL_HARDWARE_BY_ID_POST = "/api/software/info/model/hardware/list/get";
// 获取软件发布详情根据id
export const SOFTWARE_DETAIL_GET = "/api/software/info/get";
// 审批的时候获取版本发布详情
export const SOFTWARE_DETAIL_BY_TARGET_GET = "/api/software/info/by/target/detail/get";
// 查询最优升级策略(本系统使用)
export const SOFTWARE_STRATEGY_INFO_GET = "/api/software/info/optimal/strategy/list/get";
// 查询所有的升级策略
export const SOFTWARE_STRATEGY_INFO_ALL_GET = "/api/software/info/strategy/list/get";
// 获取所有现网版本升级到该版本升级策略
export const SOFTWARE_STRATEGY_INFO_ALL_LIST_GET = "/api/software/info/strategy/all/list/get";
// 获取版本发布中，待办所有的操作历史记录
export const SOFTWARE_INFO_TARGET_HISTORY_GET = "/api/software/info/target/history/get";

// 获取软件版本，型号，硬件版本对应的补丁集合(版本发布时升级策略选择关卡时使用)
export const SOFTWARE_PATCH_BY_MODEL_HARDWAREVERSION_GET = "/api/software/patch/model/hardwareversion/get";
// 获取补丁发布分页信息
export const SOFTWARE_PATCH_LIST_GET = "/api/software/patch/page/get";
// 停用补丁
export const SOFTWARE_PATCH_DEACTIVATE_POST = "/api/software/patch/deactivate";
// 启用补丁
export const SOFTWARE_PATCH_ENABLE_POST = "/api/software/patch/enable";
// 获取补丁发布详情
export const SOFTWARE_PATCH_DETAIL_GET = "/api/software/patch/get";
// 补丁发布
export const SOFTWARE_PATCH_RELEASE_POST = "/api/software/patch/release";
// 编辑补丁
export const SOFTWARE_PATCH_UPDATE_POST = "/api/software/patch/update";
// 获取软件版本，型号，硬件版本对应的补丁集合(版本发布时升级策略选择关卡时使用)
export const SOFTWARE_PATCH_CONFIG_LIST_GET = "/api/software/node/configurable/get";
// 审批时获取补丁详情
export const SOFTWARE_PATCH_DETAIL_BY_TARGET_GET = "/api/software/patch/by/target/detail/get?targetId=1";
// 获取软件版本，型号，硬件版本对应的补丁集合
export const SOFTWARE_PATCH_BY_MODEL_HARDWARE_INFO_GET = "/api/software/model/hardversion/info/patch/list/get";

// 查询所有手册字段配置
export const SOFTWARE_MANUAL_FIELD_LIST_GET = "/api/software/manual/field/list/get";
// 添加手册字段
export const SOFTWARE_MANUAL_FIELD_ADD_POST = "/api/software/manual/field/add";
// 修改手册字段配置根据id
export const SOFTWARE_MANUAL_FIELD_MOD_POST = "/api/software/manual/field/update";
// 删除字段配置
export const SOFTWARE_MANUAL_FIELD_DEL_POST = "/api/software/manual/field/del";
// 获取手册发布分页信息
export const SOFTWARE_MANUAL_LIST_GET = "/api/software/manual/page/get";
// 手册发布
export const SOFTWARE_MANUAL_RELEASE_POST = "/api/software/manual/release";
// 编辑手册
export const SOFTWARE_MANUAL_UPDATE_POST = "/api/software/manual/update";
// 获取手册发布详情根据id
export const SOFTWARE_MANUAL_DETAIL_POST = "/api/software/manual/get";
// 根据产品型号、硬件版本号，获取可配置的手册集合(软件发布时选择手册使用)
export const SOFTWARE_MANUAL_CONFIG_LIST_GET = "/api/software/manual/configurable/list/get";
// 审批时获取手册详情
export const SOFTWARE_MANUAL_DETAIL_BY_TARGET_GET = "/api/software/manual/by/target/detail/get";
/** 获取可见区域码的产品型号id，用','分割 */
export const SOFTWARE_VISIBLE_AREA_CATEGORY_GET = "/api/software/config/area/code/visible/get";
/** 更新可见区域码的产品型号id，用','分割 */
export const SOFTWARE_VISIBLE_AREA_CATEGORY_MODE_POST = "/api/software/config/area/code/visible/update";

/** 获取已发布软件版本清单 */
export const SOFTWARE_PUBLISH_LIST_GET = "/api/software/publish/list/get";
/** 置顶软件版本 */
export const SOFTWARE_TOP_POST = "/api/software/top";
/** 取消软件版本置顶 */
export const SOFTWARE_TOP_CANCEL_POST = "/api/software/top/cancel";
/** 下载软件版本并记录下载数量 */
export const SOFTWARE_DOWNLOAD_AND_COUNT = "/api/software/count/download";
/** 获取 版本发布置顶提示消息 */
export const SOFTWARE_CONFIG_TOP_MESSAGE_GET = "/api/software/config/top/message/get";
/** 配置 版本发布置顶提示消息 */
export const SOFTWARE_CONFIG_TOP_MESSAGE_MOD_GET = "/api/software/config/top/message/update";

/** 生成流水号 */
export const BILL_NUMBER_GENERATE_POST = "/api/bill/number/generate";

/** 客户报备列表 */
export const CUSTOMER_LIST_GET = "/api/user/customer/list/get";
/** 客户添加 */
export const CUSTOMER_ADD_POST = "/api/user/customer/add";
/** 客户编辑 */
export const CUSTOMER_MOD_POST = "/api/user/customer/update";
/** 客户草稿保存 */
export const CUSTOMER_DRAFT_SAVE_POST = "/api/user/customer/draft/save";
/** 获取客户详情 */
export const CUSTOMER_DETAIL_GET = "/api/user/customer/detail/get";
/** 编辑客户草稿 */
export const CUSTOMER_DRAFT_MOD_POST = "/api/user/customer/draft/update";
/** 待办获取客户详情 */
export const CUSTOMER_BY_TARGET_GET = "/api/customer/by/target/get";
/** 待办获取客户详情 */
export const CUSTOMER_HISTORY_LIST_GET = "/api/customer/history/list/get";

/** 出货条码查询 */
export const SHIPMENT_BARCODE_LIST_GET = '/api/product/delivery/bysn/get';



//isv合作
//isv合作公司列表
export const ISV_LIST_GET = "/api/isv/list/get";
//添加isv
export const ISV_ADD_POST = "/api/isv/add";
//编辑某个isv合作公司
export const ISV_UPDATE_POST = "/api/isv/update";
//删除某个isv合作
export const ISV_DELETE_POST = "/api/isv/delete";
//查看isv合作公司的具体情况
export const ISV_DETAIL_GET = "/api/isv/get";







// 和文件上传下载有关的接口
export const fileUrl = [FILE_DOWNLOAD_GET, FILE_UPLOAD_POST, FILE_UPLOAD_RETURN_ALL_POST, PROJECT_EXPORT_POST, AGENT_EXPORT,
  QUOTATION_INFO_EXPORT_GET, PRODUCT_EXPORT_GET, PRODUCT_LIST_EXPORT_POST, PRODUCT_PROMOTION_EXPORT_GET,
  DOWNLOAD_QUOTATION_RELEASE_TEMPLATE_GET, UPLOAD_QUOTATION_RELEASE_TEMPLATE_POST, SOLUTION_FILE_GET,
  ACTIVE_TEMPLATE_DOWNLOAD_GET, DOC_FILE_DOWNLOAD_POST, DOC_CENTER_FILE_DOWNLOAD_POST];

export const RETURN_DATA = [
  AUTHORIZE_INFO_BY_KEY_GET,
  COMMON_DOWNLOADING_FILE_GET,
  AUTHORIZE_ACTIVE_ADD_POST,
  TODO_AUDIT_POST,
  AUTHORIZE_IMPORT_POST,
  FILE_UPLOAD_POST,
  UPLOAD_QUOTATION_RELEASE_TEMPLATE_POST,
  TODO_RULE_MOD_POST,
  TODO_RULE_ADD_POST,
  SOFTWARE_UPDATE_POST,
  SOFTWARE_RELEASE_POST,
  SOLUTION_UPDATE_POST,
  SOLUTION_ADD_POST,
];